import html from './employee-documents-add.html';
import lang from './employee-documents-add.lang.json';
import server from '../../../client/asis-server.js';
import * as directives from '../../../client/globals/directives.js';
import * as validators from '../../../client/globals/validators.js';
import * as mixins from '../../../client/globals/mixins.js';


export default {
    template: html,

    i18n: {
        messages: lang
    },

    mixins: [mixins.loadDataOnCreate, mixins.module_name, directives.label_required, validators.vuelidate],

    data() {
        return {
            document: {},
            submit_progress: 0,
            submit_error: null,
        };
    },

    validations() {
        return {
            document: {
                document_type: {
                    required: validators.required,
                },
                issued_date: {
                    required: validators.required,
                    date: validators.asis_date,
                },
                valid_from: {
                    required: validators.required,
                    date: validators.asis_date,
                },
                valid_until: {
                    date: validators.asis_date,
                },
                ref_num: {
                    required: validators.required,
                    format: validators.regex(/^ASU-[A-Z]{3}-[0-9]{1,4}\/[0-9]{4}$/),
                },
                file: {
                    required: validators.required,
                    file: validators.file(['pdf', 'docx']),
                },
            },
        };
    },

    methods: {
        load() {
            server.request(
                this.module_name,
                'employee-documents-new',
                {pid: this.$route.params.pid},
                null,
                (data) => {
                    this.document = data;
                    this.document.ref_num = 'ASU-PAM-XXX/2026';
                }
            );
        },

        submit() {
            this.$v.$touch();
            if (this.$v.$invalid) return false;

            this.submit_error = null;
            this.submit_progress = 1;
            server.request(
                this.module_name,
                'employee-documents-add',
                this.document,
                null,
                () => {
                    this.submit_progress = 0;
                    this.$router.back();
                },
                (error) => {
                    this.submit_progress = 0;
                    this.submit_error = error;
                },
                {
                    timeout: 90000,
                    onProgress: (progress) => {
                        this.submit_progress = progress;
                    },
                }
            );
            return false;
        },
    },
};
